import { API_CRON, API_PICKER_EMP_MAPPING } from 'utils/constants'
import Api from './axiosInstance'
import { CustomObject } from 'types/common'

type FetchMasterDataParams = {
  limit: number
  page: number
}

export const getPickerMappingsApi = ({
  limit = 10,
  page = 1,
}: FetchMasterDataParams) => {
  const params = new URLSearchParams({
    limit: limit.toString(),
    page: page.toString(),
  })

  return Api.get({
    url: `${API_PICKER_EMP_MAPPING.PICKER_MAP}?${params}`,
  })
}

export const createPickerMappingApi = (data: CustomObject) => {
  return Api.post({
    url: API_PICKER_EMP_MAPPING.PICKER_MAP,
    data,
  })
}

// A row is identified by its current pickerId + pickerName
const rowUrl = (pickerId: string, pickerName: string) =>
  `${API_PICKER_EMP_MAPPING.PICKER_MAP}/${encodeURIComponent(
    pickerId,
  )}/${encodeURIComponent(pickerName)}`

export const updatePickerMappingApi = (
  current: { pickerId: string; pickerName: string },
  data: CustomObject,
) => {
  return Api.patch({
    url: rowUrl(current.pickerId, current.pickerName),
    data,
  })
}

export const deletePickerMappingApi = (current: {
  pickerId: string
  pickerName: string
}) => {
  return Api.delete({
    url: rowUrl(current.pickerId, current.pickerName),
  })
}

export const importPickerMappingApi = async (data: any) => {
  return Api.post({
    url: API_PICKER_EMP_MAPPING.IMPORT,
    data: data,
    headers: { 'Content-Type': 'multipart/form-data' },
  })
}

export const exportPickerMappingApi = () => {
  return Api.get({
    url: API_PICKER_EMP_MAPPING.EXPORT,
  })
}

export const syncEmpIdApi = () => {
  return Api.post({
    url: API_CRON.CRON_SYNC_EMP_ID,
  })
}

// View-only list of pickers synced from Order Tracker
export const getPickersApi = (params: Record<string, string | number>) => {
  const query = new URLSearchParams(
    Object.entries(params)
      .filter(([, value]) => value !== undefined && value !== '')
      .map(([key, value]) => [key, String(value)]),
  )

  return Api.get({
    url: `${API_PICKER_EMP_MAPPING.PICKERS}?${query}`,
  })
}

// Pulls every picker from Order Tracker (first load / recovery)
export const runPickerFullSyncApi = () => {
  return Api.post({
    url: API_PICKER_EMP_MAPPING.PICKERS_FULL_SYNC,
    data: {},
  })
}
